<p-dialog [modal]="true" [(visible)]="visible">
    <ng-template pTemplate="header">
        <span class="p-dialog-title">
            Enter new Forecast for {{ manufacturer.name }}
        </span>
    </ng-template>

    <p-fluid>
        <div class="field">
            <label for="planningParameter">Planning parameter</label>
            <p-select
                id="planningParameter"
                placeholder="Select a planning parameter"
                [options]="planningParameters"
                optionLabel="name"
                appendTo="body"
                [(ngModel)]="selectedPlanningParameter"
            ></p-select>
        </div>
        <div class="field">
            <label for="month">Month</label>
            <p-datepicker
                class="p-fluid"
                dateFormat="yy-mm"
                placeholder="Select a month"
                view="month"
                appendTo="body"
                [readonlyInput]="true"
                [(ngModel)]="selectedMonth"
            ></p-datepicker>
        </div>
    </p-fluid>

    <ng-template #footer>
        <p-button label="Cancel" [text]="true" severity="secondary" (click)="closeModal()"/>
        <p-button label="Save" [outlined]="true" severity="success" (click)="saveNewForecast()" />
    </ng-template>
</p-dialog>
